// Utility to extract printable ASCII characters from a string
export function extractPrintableText(input: string): string {
  // Replace non-printable ASCII (except for common whitespace) with empty string
  return input.replace(/[^\x20-\x7E\n\r\t]+/g, '');
}
